import { createAction } from 'redux-actions';
import { REPLACE_HISTORY_MESSAGE } from '../constants/actionTypes';
export const replaceHistoryMessage = createAction(REPLACE_HISTORY_MESSAGE, ({
  message,
  threadId
}) => ({
  message,
  threadId
}));